<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 入账审批</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="审批" prop="status" :rules="[{required: true, type:'number', message: '请选择审批结果', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                                        <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                            <Radio :label="2">未到账</Radio>
                                            <Radio :label="4">已到账</Radio>
                                            <Radio :label="3">驳回申请</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                                <Col span="24" v-if="Forms.status === 3">
                                    <FormItem  label="驳回原因" prop="reject_remark" :rules="[{required: true, message: '请输入驳回原因', trigger: 'blur'}]">
                                        <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="驳回原因"  />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row :gutter="32"  v-if="Forms.status === 4">
                                <Col span="8">
                                    <FormItem label="到账金额" prop="get_money" :rules="[{ required: true, type: 'number',  message: '请输入到账金额', trigger: 'blur',  transform(value) { return parseFloat(value)}}]">
                                        <Input v-model="Forms.get_money" type="number" class="width-100" clearable placeholder="如：10000" />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="到账时间" prop="get_date" :rules="[{required: true, type:'date', message: '请选择到账时间', trigger: 'change'}]">
                                        <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.get_date" placeholder="到账时间" class="width-100"  />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="收款账户" prop="get_bank" :rules="[{required: true, type:'number', message: '请选择收款账户', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                                        <Select v-model="Forms.get_bank" clearable filterable  placeholder="收款账户" class="width-100">
                                            <Option v-for="(item,index) in bankList" :key="index" :value="item.id">{{item.account}}({{item.company}}{{item.bank}})</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col span="24">
                                  <FormItem label="到账凭证" prop="get_voucher" :rules="[{required: true, validator(rule, value, callback){ if(!value || value.length === 0 || !value[0]){ return callback(new Error('请上传到账凭证')) } callback() }, trigger: 'change'}]">
                                    <Input v-model="Forms.get_voucher[0]" disabled>
                                      <template #append>
                                        <div class="f-center">
                                          <Upload
                                              :show-upload-list="false"
                                              :action="upload_url"
                                              :headers = "{'token': $store.state.token}"
                                              :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png','pdf']"
                                              :max-size="50 * 1024"
                                              :on-success="handleSuccess"
                                              :on-format-error="handleFormatError"
                                              :on-exceeded-size="handleMaxSize">
                                            <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                          </Upload>
                                          <Divider type="vertical" />
                                          <a href="javascript:void(0);" @click="FileDelete('get_voucher')" class="text-danger"><Icon type="md-trash" />删除</a>
                                          <Divider type="vertical" />
                                          <a href="javascript:void(0);" @click="FileDownload(Forms.get_voucher[0])" class="text-violet"><Icon type="md-download" />下载</a>
                                        </div>
                                      </template>
                                    </Input>
                                  </FormItem>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 收款信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="零星项目：">
                                    {{detail.project_name}}
                                </Description>
                                <Description term="甲方：">
                                    {{detail.customer_name ?? '-'}}
                                </Description>
                                <Description term="维保记录：">
                                    {{detail.maintain_title ?? '-'}}
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                                <Description term="不含税金额：">
                                    <Tag color="blue">{{detail.money}}</Tag>
                                </Description>
                                <Description term="费率：">
                                    <Tag>{{detail.tax_rate}} %</Tag>
                                </Description>
                                <Description term="税费：">
                                    <Tag>{{detail.tax_money}}</Tag>
                                </Description>
                                <Description term="含税金额：">
                                    <Tag color="green">{{detail.true_money}}</Tag>
                                </Description>
                                <Description term="收款类型：">
                                    <Tag>{{detail.type_name}}</Tag>
                                </Description>
                                <Description term="申请人：">
                                    {{detail.apply_name}}
                                </Description>
                                <Description term="申请时间：">
                                    {{detail.apply_time}}
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                                <Description term="备注信息：">
                                    {{detail.remark}}
                                </Description>
                            </DescriptionList>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认审批</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {examineDispersedIncome, getDispersedIncomeConfig, getDispersedIncomeDetail} from "@/apis/dispersed";

export default {
    name: 'DispersedIncomeExamine',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '入账审批',
            isBox : false,
            bankList: [],
            detail: [],
            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            Forms : {
                income_id: '',
                status: '',
                reject_remark: '',
                get_money: '',
                get_date: '',
                get_bank: '',
                get_voucher: [],
            },
            Rules : {

            }
        }
    },
    methods: {
      /**
       功能：文件删除
       time: 2026/09/12
       **/
      FileDelete(f){
        let that = this;
        that.Forms[f] = [];
      },
      /**
       功能：文件下载
       time: 2026/09/12
       **/
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
        /**
         功能：上传成功
         time: 2026/09/12
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.get_voucher = [res.data.url];
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | pdf | doc | docx | xls | xlsx | rar | zip 文件' });
            return false;
        },
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：配置
         time: 2026/09/12
         **/
        GetConfig(){
            let that = this;
            getDispersedIncomeConfig().then(e=>{
                that.bankList = e.data.bankList ?? [];
            })
        },
        /**
         功能：详情
         time: 2026/09/12
         **/
        GetDetail(income_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedIncomeDetail(income_id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         功能：打开
         time: 2026/09/12
         **/
        show(income_id, project_name){
            this.isBox = true;
            this.title = project_name + ' - 入账审批';
            if(income_id){
                this.Forms.income_id = income_id;
                this.GetDetail(income_id);
            }
            this.GetConfig();
        },
        /**
         功能：提交
         time: 2026/09/12
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    let param = JSON.parse(JSON.stringify(that.Forms));
                    if(param.get_date && typeof param.get_date !== 'string'){
                        const d = new Date(param.get_date);
                        const month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
                        const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
                        param.get_date = d.getFullYear() + '-' + month + '-' + day;
                    }
                    that.$store.commit('SET_LOADING' , true);
                    examineDispersedIncome(param).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '入账审批';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                income_id: '',
                status: '',
                reject_remark: '',
                get_money: '',
                get_date: '',
                get_bank: '',
                get_voucher: [],
            };
            this.bankList = [];
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
